import {
    getMenuCategoriesFromFirebase,
    getSaveOrderBasketItemsFirestoreRef,
    getSaveOrderInfoFirestoreRef,
    saveOrderInfoToFirebase
} from "../database/firebase";
import { getCourseInfoFromFirebase, getCourseMenuItemsFromFirebase } from "../database/firebase";
import {IOrderInfo} from "../interfaces/IOrderInfo";
import {DatabaseReference} from "firebase/database";

export const storeSuccessfulPayment = () => {
    
}

export function saveOrderInfo(orderInfo: IOrderInfo, courseId: string): DatabaseReference {
    return saveOrderInfoToFirebase(courseId);
}

export function getSaveOrderInfoRef(courseId: string) {
    return getSaveOrderInfoFirestoreRef(courseId);
}

export function getSaveOrderBasketItemsRef(courseId: string, orderId: string) {
    return getSaveOrderBasketItemsFirestoreRef(courseId, orderId);
}

export async function getCourseInfo(courseId: string) {
    const course = await getCourseInfoFromFirebase(courseId);
    return course;
}

export async function getMenuCategories(courseId: string) {
    const categories = await getMenuCategoriesFromFirebase(courseId);
    return categories;
}

export async function getMenuItems(courseId: string) {
    const items = await getCourseMenuItemsFromFirebase(courseId);
    return items;
}
